((app, ng) => {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Client.Personal",
                {
                    url: "/Personal",
                    component: "clientPersonal",
                    resolve: {
                        prefixes: ["prefixes", function (prefixes) {
                            return prefixes;
                        }],
                        suffixes: ["suffixes", function (suffixes) {
                            return suffixes;
                        }],
                        genders: ["genders", function (genders) {
                            return genders;
                        }],
                        phoneNumberTypes: ["phoneNumberTypes", function (phoneNumberTypes) {
                            return phoneNumberTypes;
                        }],
                        emailAddressTypes: ["emailAddressTypes", function (emailAddressTypes) {
                            return emailAddressTypes;
                        }],
                        physicalAddressTypes: ["physicalAddressTypes", function (physicalAddressTypes) {
                            return physicalAddressTypes;
                        }],
                        states: ["_states", function (states) {
                            return states;
                        }],
                        clientTypes: ["clientApi", function (clientApi) {
                            return clientApi.getClientTypes();
                        }],
                        clientPhoneNumbers: ["personApi", "laterLoad", "client", function (personApi, laterLoad, client) {
                            return personApi.getPhoneNumbers(client.Id);
                        }],
                        clientEmailAddresses: ["personApi", "laterLoad", "client", function (personApi, laterLoad, client) {
                            return personApi.getEmailAddresses(client.Id);
                        }],
                        clientPhysicalAddresses: ["personApi", "laterLoad", "client", function (personApi, laterLoad, client) {
                            return personApi.getPhysicalAddresses(client.Id);
                        }],
                        primaryAdvisor: ["primaryAdvisor", function (primaryAdvisor) {
                            return primaryAdvisor;
                        }],
                        clientHouseholdRelationships: ["householdRelationshipApi", "client", function (householdRelationshipApi, client) {
                            return householdRelationshipApi.getHouseholdRelationships(client.Id);
                        }],
                        referrals: ["clientApi", "client", function (clientApi, client) {
                            return clientApi.getReferrals(client.Id);
                        }],
                        preferredCommunication: ["_preferredCommunications", function (preferredCommunication) {
                            return preferredCommunication;
                        }],
                        ssn: ["personApi", "client", function (personApi, client) {
                            return personApi.getSsn(client.Id);
                        }]
                    },
                    data: {
                        pageTitle: "Personal"
                    }
                });
        }
    ]);

    app.component("clientPersonal",
        {
            transclude: true,
            templateUrl: "/App/Client/Personal/personal-template.html",
            controller: clientPersonalController,
            require: {
                parent: "^client"
            },
            bindings: {
                currentUser: "<",
                client: "<",
                prefixes: "<",
                suffixes: "<",
                genders: "<",
                phoneNumberTypes: "<",
                emailAddressTypes: "<",
                physicalAddressTypes: "<",
                states: "<",
                clientTypes: "<",
                clientPhoneNumbers: "<",
                clientEmailAddresses: "<",
                clientPhysicalAddresses: "<",
                primaryAdvisor: "<",
                tags: "<",
                clientHouseholdRelationships: "<",
                referrals: "<",
                preferredCommunication: "<",
                ssn: "<"
            }
        });

    clientPersonalController.$inject = ["_", "advisorApi", "clientApi", "customFieldApi", "FieldStatusesModel", "_formPattern", "_householdRelationshipTypes", "householdRelationshipApi", "$mdDialog", "moment", "personApi", "$q", "responseStatus", "$rootScope", "$state", "tagApi"];
    function clientPersonalController(_, advisorApi, clientApi, customFieldApi, FieldStatusesModel, formPattern, householdRelationshipTypes, householdRelationshipApi, $mdDialog, moment, personApi, $q, responseStatus, $rootScope, $state, tagApi) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
                ui: {
                    loading: false,
                    Dob: null,
                    driverLicenseExpirationDate: null,
                    medicarePartAStartDate: null,
                    medicarePartBStartDate: null
                },
                datePicker: {
                    days: [],
                    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "July", "Aug", "Sept", "Oct", "Nov", "Dec"],
                    years: []
                },
                addContact: addContact,
                addTag: addTag,
                advisorSelectedItemChange: advisorSelectedItemChange,
                deleteClientReferral: deleteClientReferral,
                deleteHouseholdEntity: deleteHouseholdEntity,
                formPattern: formPattern,
                householdRelationshipTypes: householdRelationshipTypes,
                onRelationshipClick: onRelationshipClick,
                openAddClientReferral: openAddClientReferral,
                openAddHouseholdEntity: openAddHouseholdEntity,
                openEditHouseholdEntity: openEditHouseholdEntity,
                openEditPrimaryAdvisor: openEditPrimaryAdvisor,
                removeContact: removeContact,
                removeTag: removeTag,
                responseStatus: responseStatus,
                searchAdvisors: searchAdvisors,
                searchTags: searchTags,
                ssnUpdated: ssnUpdated,
                transformTag: transformTag,
                updateClient: updateClient,
                updateContact: updateContact,
                updateCustomField: updateCustomField,
                updatePerson: updatePerson,
                updatePrimaryContact: updatePrimaryContact,
                updateRelationshipType: updateRelationshipType
            });

        $rootScope.$on("loadingClientSubstate",
            function () {
                $ctrl.ui.loading = true;
            });

        //CLIENT 
        function updateClient(editedField) {
            $ctrl.savingStatusForClient.findFieldStatusByName(editedField).startSaving();
            $ctrl.ui.saving = true;

            $ctrl.client.DriverLicenseExpirationDate = $ctrl.ui.driverLicenseExpirationDate ? new Date($ctrl.ui.driverLicenseExpirationDate) : null;
            $ctrl.client.MedicarePartAStartDate = $ctrl.ui.medicarePartAStartDate ? new Date($ctrl.ui.medicarePartAStartDate) : null;
            $ctrl.client.MedicarePartBStartDate = $ctrl.ui.medicarePartBStartDate ? new Date($ctrl.ui.medicarePartBStartDate) : null;

            if ($ctrl.client.TypeId !== $ctrl.client.Type.Id) {
                $ctrl.client.Type = _.find($ctrl.clientTypes, { 'Id': $ctrl.client.TypeId });
            }

            return clientApi.update($ctrl.client).then(function () {
                $ctrl.savingStatusForClient.findFieldStatusByName(editedField).succeed();
                $ctrl.ui.saving = false;
            }).catch(function () {
                $ctrl.savingStatusForClient.findFieldStatusByName(editedField).fail();
            });
        }

        function updatePerson(editedField) {
            $ctrl.savingStatusForPerson.findFieldStatusByName(editedField).startSaving();
            $ctrl.ui.saving = true;

            $ctrl.client.Person.Dob = $ctrl.ui.Dob ? new Date($ctrl.ui.Dob) : null;

            personApi.update($ctrl.client.Person)
                .then(function () {
                    $ctrl.savingStatusForPerson.findFieldStatusByName(editedField).succeed();
                    $ctrl.ui.saving = false;
                }).catch(function () {
                    $ctrl.savingStatusForPerson.findFieldStatusByName(editedField).fail();
                });
        }

        function ssnUpdated(editBasicInfo) {
            $ctrl.savingStatusForSSN.findFieldStatusByName("SSN").startSaving();
            if ($ctrl.client.Person.Ssn && $ctrl.client.Person.Ssn.length === 9 && /^\d+$/.test($ctrl.client.Person.Ssn)) {
                $ctrl.focusInput = false;
                $ctrl.ui.saving = true;
                $ctrl.client.Person.LastFourSsn = $ctrl.client.Person.Ssn.substring($ctrl.client.Person.Ssn.length - 4);
                editBasicInfo.SsN.$error.ssnInvalid = false;
                $ctrl.ui.showFullSsn = false;
                if ($ctrl.previousSsn !== $ctrl.client.Person.Ssn) {
                    personApi.updateSsn($ctrl.client.Person.Id, { Ssn: $ctrl.client.Person.Ssn }).then(function () {
                        $ctrl.previousSsn = $ctrl.client.Person.Ssn;
                        $ctrl.client.Person.LastFourSsn = $ctrl.client.Person.Ssn
                            .substring($ctrl.client.Person.Ssn.length - 4);
                        $ctrl.ui.ssnChanged = false;
                        $ctrl.ui.showFullSsn = false;
                        $ctrl.savingStatusForSSN.findFieldStatusByName("SSN").succeed();
                    }).catch(function () {
                        $ctrl.savingStatusForSSN.findFieldStatusByName("SSN").fail();
                    });
                }
            } else {
                if (!$ctrl.client.Person.Ssn) {
                    editBasicInfo.SsN.$error.ssnInvalid = false;
                    $ctrl.ui.saving = true;
                    personApi.removeSsn($ctrl.client.Person.Id).then(function () {
                        $ctrl.savingStatusForSSN.findFieldStatusByName("SSN").succeed();
                        $ctrl.ui.ssnChanged = false;
                        $ctrl.client.Person.LastFourSsn = null;
                    }).catch(function () {
                        $ctrl.savingStatusForSSN.findFieldStatusByName("SSN").fail();
                    });
                } else {
                    $ctrl.savingStatusForSSN.findFieldStatusByName("SSN").clearStatus();
                    editBasicInfo.SsN.$error.ssnInvalid = true;
                }
                $ctrl.ui.showFullSsn = true;
            }
            $ctrl.ui.saving = false;
        }

        function updateCustomField(updatedField, fieldIndex) {
            $ctrl.savingStatusForCustomFields.fields[fieldIndex].startSaving();
            $ctrl.ui.saving = true;
            //sanitize custom field entry
            var updateEntry = {
                Id: updatedField.Id,
                CustomFieldId: updatedField.CustomFieldId,
                ClientId: updatedField.ClientId,
                TextAnswer: !!updatedField.TextAnswer ? updatedField.TextAnswer : '',
                DateTimeAnswer: !!updatedField.DateTimeAnswer ? new Date(updatedField.DateTimeAnswer) : null,
                TextOptionsAnswerList: null
            };
            return customFieldApi.updateClientEntry(updateEntry)
                .then((response) => {
                    $ctrl.savingStatusForCustomFields.fields[fieldIndex].succeed();
                    if (!!response) { updatedField.Id = response.Id; }
                })
                .catch((error) => {
                    console.log("Error", error);
                    $ctrl.savingStatusForCustomFields.fields[fieldIndex].fail();
                })
                .finally(() => { $ctrl.ui.saving = false; });
        }

        //CONTACTS
        function addContact(list, obj) {
            if (!_.find(list, function (row) { return !row.Id; })) {
                list.push(obj);
            }
        }

        function updatePrimaryContact(obj, type) {
            ng.forEach($ctrl["client" + type],
                function (contact) {
                    contact.Preferred = false;
                });

            personApi["updatePrimary" + type]($ctrl.client.Id, obj).then(function (response) {
                $ctrl.client.Person["Primary" + type] = response;
                $ctrl.client.Person["Primary" + type + "Id"] = obj.Id;
                obj.Preferred = true;
                if (type === "PhoneNumber") {
                    $rootScope.$emit("primaryPhoneNumberUpdated", obj);
                }
                else if (type === "EmailAddress") {
                    $rootScope.$emit("primaryEmailAddressUpdated", obj);
                }
                else if (type === "PhysicalAddress") {
                    $rootScope.$emit("primaryPhysicalAddressUpdated", obj);
                }
                $ctrl.ui["saving" + type] = false;
                filterPreferredCommunication();
            });
        }

        function updateContact(obj, type) {
            $ctrl.ui["saving" + type] = true;
            if (obj.Id) {
                //existing object
                personApi["update" + type]($ctrl.client.Id, obj).then(function (response) {
                    obj.Edit = false;
                    if (obj.Preferred) {
                        $ctrl.updatePrimaryContact(response, type);
                    }
                    else {
                        $ctrl.ui["saving" + type] = false;
                        filterPreferredCommunication();
                    }

                });

            }
            else {
                //new object
                personApi["add" + type]($ctrl.client.Id, obj).then(function (newObj) {
                    obj.Id = newObj.Id;
                    obj.Edit = false;
                    if (obj.Preferred) {
                        $ctrl.updatePrimaryContact(obj, type);
                    }
                    else {
                        $ctrl.ui["saving" + type] = false;
                        filterPreferredCommunication();
                    }
                });
            }
        }

        function removeContact(obj, list, type) {
            var confirmDelete = $mdDialog.confirm({
                focusOnOpen: false,
                theme: "confirmDelete",
                title: "Are you sure you wish to delete this information?",
                ariaLabel: "Confirm Delete",
                ok: "Delete",
                cancel: "Cancel",
                onComplete: function () {
                    var $dialog = ng.element(document.querySelector("md-dialog"));
                    var $actionsSection = $dialog.find("md-dialog-actions");
                    var $cancelButton = $actionsSection.children()[0];
                    $cancelButton.focus();
                }
            });
            $mdDialog.show(confirmDelete)
                .then(function () {
                    var index = _.findIndex(list, function (row) { return row === obj; });
                    list.splice(index, 1);

                    if (obj.Id) {

                        //the object has been added to the database
                        if (obj.Id === $ctrl.client.Person["Primary" + type + "Id"]) {
                            //we are deleting the primary contact item
                            personApi["remove" + type]($ctrl.client.Id, obj).then(function () {

                                //if there is something to assign as the new primary
                                if (list.length > 0) {
                                    updatePrimaryContact(list[0], type);
                                    if (type === "PhoneNumber")
                                        $rootScope.$emit("primaryPhoneNumberUpdated", list[0]);
                                    else if (type === "EmailAddress")
                                        $rootScope.$emit("primaryEmailAddressUpdated", list[0]);
                                    else if (type === "PhysicalAddress")
                                        $rootScope.$emit("primaryPhysicalAddressUpdated", list[0]);
                                }
                                else {

                                    $ctrl.client.Person["Primary" + type] = null;
                                    $ctrl.client.Person["Primary" + type + "Id"] = null;

                                    if (type === "PhoneNumber")
                                        $rootScope.$emit("primaryPhoneNumberUpdated", null);
                                    else if (type === "EmailAddress")
                                        $rootScope.$emit("primaryEmailAddressUpdated", null);
                                    else if (type === "PhysicalAddress")
                                        $rootScope.$emit("primaryPhysicalAddressUpdated", null);
                                    filterPreferredCommunication();
                                }

                            });
                        }
                        else {
                            //not primary
                            personApi["remove" + type]($ctrl.client.Id, obj).then(function () {
                                filterPreferredCommunication();
                            });
                        }

                    }
                });
        }

        //PRIMARY ADVISOR
        function searchAdvisors(term) {
            return advisorApi.searchAdvisors(term).then(function (result) {
                _.remove(result, function (row) { return row.Id === $ctrl.client.Id; });
                ng.forEach(result,
                    function (row) {
                        row.Term = row.Person.FirstName + " " + row.Person.LastName;
                    });
                return result;
            });
        }

        function advisorSelectedItemChange(term, $event) {
            if (term) {

                if ($ctrl.primaryAdvisor.Id !== $ctrl.currentUser.AdvisorId &&
                    !_.find($ctrl.currentUser.ParentUsers,
                        function (parent) { return parent.AdvisorId === $ctrl.primaryAdvisor.Id; })) {
                    $mdDialog.show($mdDialog.confirm({
                        focusOnOpen: false,
                        clickOutsideToClose: false,
                        targetEvent: $event,
                        title: "Are you sure you want to update the primary advisor?",
                        textContent: "You will lose access to " +
                            $ctrl.client.Person.FirstName +
                            " " +
                            $ctrl.client.Person.LastName +
                            " if you change the advisor to " +
                            $ctrl.primaryAdvisor.Person.FirstName +
                            " " +
                            $ctrl.primaryAdvisor.Person.LastName +
                            ".",
                        ariaLabel: "Confirm primary advisor update",
                        ok: "Yes",
                        cancel: "No"
                    })).then(function () {
                        $ctrl.parent.ui.loading = true;
                        updateAdvisor().then(function () {
                            $state.go("Home.Contacts");
                        });
                    });
                } else {
                    updateAdvisor();
                }
            }
        }

        function updateAdvisor() {
            $ctrl.savingStatusForAdvisor.findFieldStatusByName("PrimaryAdvisor").startSaving();
            $rootScope.$emit("primaryAdvisorUpdated", $ctrl.primaryAdvisor);
            $ctrl.client.PrimaryAdvisorId = $ctrl.primaryAdvisor.Id;
            return clientApi.updateClientPrimaryAdvisor($ctrl.client.Id, $ctrl.primaryAdvisor)
                .then(function () {
                    return $ctrl.savingStatusForAdvisor.findFieldStatusByName("PrimaryAdvisor").succeed();
                }).catch(function () {
                    return $ctrl.savingStatusForAdvisor.findFieldStatusByName("PrimaryAdvisor").fail();
                });
        }

        function openEditPrimaryAdvisor($event) {
            var alert = $mdDialog.alert({
                templateUrl: "/App/Client/Personal/EditPrimaryAdvisor/template.html",
                controller: "editPrimaryAdvisorController as $ctrl",
                resolve: {
                    advisor: [
                        function () {
                            return !$ctrl.primaryAdvisor.Id ? null : $ctrl.primaryAdvisor;
                        }
                    ],
                    client: [
                        function () {
                            return $ctrl.client;
                        }
                    ]
                },
                targetEvent: $event,
                clickOutsideToClose: false
            });
            $mdDialog.show(alert).then(function (advisor) {
                if (!advisor)
                    $ctrl.primaryAdvisor = {};
                else
                    ng.merge($ctrl.primaryAdvisor, advisor);
            });
        }

        //TAGS
        function addTag(tag) {
            var promises = [];
            if (!tag.Id) {
                promises.push(tagApi.add(tag)
                    .then(function (response) {
                        return tag.Id = response.Id;
                    }));
            }
            $q.all(promises)
                .then(function () {
                    return clientApi.addClientTag($ctrl.client.Id, tag);
                });
        }

        function removeTag(tag) {
            return clientApi.removeClientTag($ctrl.client.Id, tag.Id);
        }

        function transformTag(tag) {
            if (tag.Id)
                return tag;
            return { Value: tag };
        }

        function searchTags(term) {
            return tagApi.search(term);
        }

        //HOUSEHOLD
        function onRelationshipClick(relationship) {
            if ($ctrl.ui.isEditingRelationships) return;

            if (relationship.Type !== "Trust")
                $state.go("Home.Client", { clientId: clientId });
            else
                //TODO open trust edit
                return;
        }

        function openAddHouseholdEntity($event) {
            var alert = $mdDialog.alert({
                focusOnOpen: false,
                templateUrl: "/App/Client/Personal/AddHouseholdRelationship/add-household-relationship.template.html",
                controller: "addHouseholdRelationshipController as $ctrl",
                locals: {
                    client: $ctrl.client,
                    states: $ctrl.states,
                    phoneNumberTypes: $ctrl.phoneNumberTypes,
                    emailAddressTypes: $ctrl.emailAddressTypes,
                    physicalAddressTypes: $ctrl.physicalAddressTypes,
                    household: $ctrl.clientHouseholdRelationships
                },
                resolve: {
                    clientTypes: ["clientApi", function (clientApi) {
                        return clientApi.getClientTypes();
                    }]
                },
                targetEvent: $event,
                clickOutsideToClose: true
            });
            return $mdDialog.show(alert).then(function (relationship) {
                if (!!relationship)
                    $ctrl.clientHouseholdRelationships.push(relationship);
            });
        }

        function openEditHouseholdEntity(relationship, $event) {
            $ctrl.ui.isEditingRelationships = true;

            var alert = $mdDialog.alert({
                clickOutsideToClose: false,
                focusOnOpen: false,
                templateUrl: "/App/Client/Personal/EditHouseholdRelationship/template.html",
                controller: "editHouseholdRelationshipController as $ctrl",
                resolve: {
                    relationship: [function () { return relationship; }],
                    clientPhysicalAddresses: [function () {
                        return personApi.getPhysicalAddresses(relationship.TargetClient.Id);
                    }],
                    clientPhoneNumbers: [function () {
                        return personApi.getPhoneNumbers(relationship.TargetClient.Id);
                    }],
                    clientEmailAddresses: [function () {
                        return personApi.getEmailAddresses(relationship.TargetClient.Id);
                    }]
                },
                targetEvent: $event
            });
            return $mdDialog.show(alert).then(function (response) {
                //$ctrl.ui.isEditingRelationships = false;
                if (!!response) {
                    var index = $ctrl.clientHouseholdRelationships.indexOf(relationship);
                    $ctrl.clientHouseholdRelationships[index] = response;
                    return $ctrl.ui.isEditingRelationships = false;
                }
                return response;

            });
        }

        function updateRelationshipType(relationship) {
            $ctrl.ui.updatingRelationshipType = true;
            return householdRelationshipApi.updateType(relationship)
                .finally(() => {
                    $ctrl.ui.updatingRelationshipType = false;
                    relationship.Edit = false;
                });
        }

        function deleteHouseholdEntity(relationship, $event) {
            $ctrl.ui.isEditingRelationships = true;

            var name = relationship.Type === "Trust"
                ? relationship.TargetTrust.Name
                : relationship.TargetClient.Person.FirstName;

            var confirm = $mdDialog.confirm({
                theme: "confirmDelete",
                title: "Are you sure you would like to remove " +
                    $ctrl.client.Person.FirstName +
                    "'s relationship with " +
                    name +
                    "?",
                ariaLabel: "Remove relationship",
                targetEvent: $event,
                ok: "Remove",
                cancel: "Cancel",
                onComplete: function () {
                    var $dialog = ng.element(document.querySelector("md-dialog"));
                    var $actionsSection = $dialog.find("md-dialog-actions");
                    var $cancelButton = $actionsSection.children()[0];
                    $cancelButton.focus();
                }
            });

            $mdDialog.show(confirm).then(function () {
                var promises = [];
                promises.push(householdRelationshipApi.deleteHouseholdRelationship(relationship.Id));
                promises.push(householdRelationshipApi.getHouseholdRelationships(relationship.TargetClient.Id)
                    .then(function (relationships) {
                        var reverse = _.find(relationships,
                            function (row) {
                                return row.TargetClient.Id === relationship.SourceClient.Id;
                            });
                        if (reverse) {
                            return householdRelationshipApi.deleteHouseholdRelationship(reverse.Id);
                        }
                        return null;
                    }));

                return $q.all(promises).then(function () {
                    var index = _.findIndex($ctrl.clientHouseholdRelationships,
                        function (row) { return row.Id === relationship.Id; });
                    if (index !== -1)
                        $ctrl.clientHouseholdRelationships.splice(index, 1);
                    $ctrl.ui.isEditingRelationships = false;
                });
            });
        }
        //REFERRALS
        function openAddClientReferral($event) {

            var alert = $mdDialog.alert({
                focusOnOpen: false,
                templateUrl: "/App/Client/Personal/EditClientReferral/edit-client-referral-template.html",
                controller: "editClientReferralController as $ctrl",
                locals: {
                    client: $ctrl.client,
                    referrals: $ctrl.referrals
                },
                resolve: {
                    //referredBy: [
                    //    function () {
                    //        if ($ctrl.clientReferredBy === undefined) return null;
                    //        return !$ctrl.clientReferredBy.Id ? null : $ctrl.clientReferredBy;
                    //    }
                    //]
                },
                targetEvent: $event,
                clickOutsideToClose: false
            });
            $mdDialog.show(alert);
        }

        $rootScope.$on("referralAdded",
            function (event, referral) {
                $ctrl.referrals.push(referral);
            });

        function deleteClientReferral(clientReferralId, $event) {
            var confirm = $mdDialog.confirm({
                focusOnOpen: false,
                theme: "confirmDelete",
                title: "Are you sure you would like to remove this referral?",
                ariaLabel: "Remove referral",
                targetEvent: $event,
                ok: "Remove",
                cancel: "Cancel"
            });

            $mdDialog.show(confirm).then(function () {
                _.remove($ctrl.referrals,
                    function (referral) {
                        return referral.ClientReferralId === clientReferralId;
                    });

                clientApi.removeClientReferral(clientReferralId)
                    .then((response) => { })
                    .catch((error) => { console.log("Error", error); });
            });
        }

        function filterPreferredCommunication() {
            $ctrl.filteredPreferredCommunication = $ctrl.preferredCommunication.slice();

            _.remove($ctrl.filteredPreferredCommunication,
                function (comm) {
                    switch (comm.ShortName) {
                        case "Fax":
                            return !$ctrl.client.Person.PrimaryPhoneNumber ||
                                $ctrl.client.Person.PrimaryPhoneNumber.Type !== "Fax";
                        case "CallBusiness":
                            return !$ctrl.client.Person.PrimaryPhoneNumber ||
                                $ctrl.client.Person.PrimaryPhoneNumber.Type !== "Business";
                        case "CallIsdn":
                            return !$ctrl.client.Person.PrimaryPhoneNumber ||
                                $ctrl.client.Person.PrimaryPhoneNumber.Type !== "Isdn";
                        case "CallHome":
                            return !$ctrl.client.Person.PrimaryPhoneNumber ||
                                $ctrl.client.Person.PrimaryPhoneNumber.Type !== "Home";
                        case "CallOther":
                            return !$ctrl.client.Person.PrimaryPhoneNumber ||
                                $ctrl.client.Person.PrimaryPhoneNumber.Type !== "Other";
                        case "CallCell":
                        case "TextCell":
                            return !$ctrl.client.Person.PrimaryPhoneNumber ||
                                $ctrl.client.Person.PrimaryPhoneNumber.Type !== "Cell";
                        case "EmailBusiness":
                            return !$ctrl.client.Person.PrimaryEmailAddress ||
                                $ctrl.client.Person.PrimaryEmailAddress.Type !== "Business";
                        case "EmailPersonal":
                            return !$ctrl.client.Person.PrimaryEmailAddress ||
                                $ctrl.client.Person.PrimaryEmailAddress.Type !== "Personal";
                        case "EmailOther":
                            return !$ctrl.client.Person.PrimaryEmailAddress ||
                                $ctrl.client.Person.PrimaryEmailAddress.Type !== "Other";
                        default:
                            return true;
                    }
                });
        }

        function setContactDates() {
            $ctrl.ui.Dob = $ctrl.client.Person.Dob ? moment.utc($ctrl.client.Person.Dob).format("L") : null;
            $ctrl.ui.driverLicenseExpirationDate = $ctrl.client.DriverLicenseExpirationDate ? moment.utc($ctrl.client.DriverLicenseExpirationDate).format("L") : null;
            $ctrl.ui.medicarePartAStartDate = $ctrl.client.MedicarePartAStartDate ? moment.utc($ctrl.client.MedicarePartAStartDate).format("L") : null;
            $ctrl.ui.medicarePartBStartDate = $ctrl.client.MedicarePartBStartDate ? moment.utc($ctrl.client.MedicarePartBStartDate).format("L") : null;
        }

        $ctrl.$onInit = () => {
            setContactDates();
            $ctrl.savingStatusForPerson = new FieldStatusesModel($ctrl.client.Person);
            $ctrl.savingStatusForClient = new FieldStatusesModel($ctrl.client);
            $ctrl.savingStatusForCustomFields = new FieldStatusesModel($ctrl.client.CustomFields);
            $ctrl.savingStatusForAdvisor = new FieldStatusesModel({ PrimaryAdvisor: "" });
            $ctrl.savingStatusForSSN = new FieldStatusesModel({ SSN: "" });
            $ctrl.client.Person.Ssn = $ctrl.ssn.Ssn;
            $ctrl.previousSsn = $ctrl.ssn.Ssn;
            _.forEach($ctrl.client.CustomFields, (field) => {
                if (field.CustomFieldType === 'DateTime') {
                    field.ClientEntryModel.DateTimeAnswer = field.ClientEntryModel.DateTimeAnswer ? moment.utc(field.ClientEntryModel.DateTimeAnswer).format("L") : null;
                }
            });
            if (!$ctrl.client.Person.LastFourSsn)
                $ctrl.ui.showFullSsn = true;

            if ($ctrl.primaryAdvisor && $ctrl.primaryAdvisor.Person) {
                $ctrl.primaryAdvisor.Term = $ctrl.primaryAdvisor.Person.FirstName + " " + $ctrl.primaryAdvisor.Person.LastName;
                $ctrl.client.PrimaryAdvisorId = $ctrl.primaryAdvisor.Id;
            }
            else {
                $ctrl.primaryAdvisor = null;
            }

            filterPreferredCommunication();
        }
    }

})(window.app, window.angular); //jshint ignore:line